import { Injectable, ViewContainerRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AuxiliaryDataFieldSchemaInterface, AuxiliaryDataSearchFilterInterface } from '@vendasta/account-group';
import { FilterGroup, FilterService } from '@vendasta/va-filter2';
import {
  AuxiliaryDataFieldOperation,
  AuxiliaryDataFilterControl,
} from './custom-table-filters/custom-field-filter-control';

export interface AuxiliaryDataSearchInfoInterface {
  filter: AuxiliaryDataSearchFilterInterface;
  fieldName: string;
  filterValue: string;
  operationName?: string;
}

@Injectable()
export class AccountsAuxiliaryDataTableFilterService {
  filters: FilterGroup = new FilterGroup('accounts-custom-fields');

  constructor(private readonly filterService: FilterService) {
    this.filters.addSection(
      'Custom field filters',
      [
        new AuxiliaryDataFilterControl('fieldFilter', 'Custom field', null, {
          appliedValueMapper: (name, value) => {
            if (!value) {
              return null;
            }
            return { name, label: `${value.fieldName} ${value.operationName} ${value.filterValue}` };
          },
        }),
      ],
      true,
    );
  }
}

export interface FilterHandler {
  schema: AuxiliaryDataFieldSchemaInterface;
  formControl: UntypedFormControl;

  render(viewContainerRef: ViewContainerRef): void;

  filterOperation(operation: AuxiliaryDataFieldOperation): AuxiliaryDataSearchInfoInterface;

  hasModification(): boolean;
}
